var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 18C11.8511 17.9999 13.6447 17.3581 15.0754 16.1839C16.506 15.0097 17.4853 13.3757 17.8464 11.5605C18.2074 9.74517 17.9278 7.86087 17.0552 6.2286C16.1827 4.59633 14.7712 3.3171 13.0613 2.60887C11.3513 1.90064 9.4486 1.80723 7.67747 2.34455C5.90635 2.88187 4.37635 4.01668 3.34813 5.55563C2.3199 7.09457 1.85709 8.94243 2.03856 10.7844C2.22002 12.6263 3.03453 14.3483 4.3433 15.657C5.0862 16.3999 5.96813 16.9891 6.93876 17.3911C7.90939 17.7931 8.9497 18 10.0003 18Z",
    stroke: "#525252",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0005 22L18.0005 18",
    stroke: "#525252",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.3fe8172a3d384a4ae8efa70ae188914c.svg";
export { ForwardRef as ReactComponent };